<script>
    import 'vue-strap/dist/vue-strap-lang';
    import { datepicker } from 'vue-strap';

    export default {
        components: { datepicker },
        props: {
            solicitacao: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                configuracao: this.$storage.configuracao(),
            }
        },
        computed: {

        },
        methods: {
            validar(valido) {
                if (!valido) throw new Error("validacao com erro");

                return this.$validator.validateAll();
            },
        },
        mounted() {
        },
        watch: {

        }
    }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('salarioBruto')}">
          <label class="control-label" for="salarioBruto">Salário bruto</label>

          <input type="text"
                 class="form-control text-right"
                 id="salarioBruto"
                 v-model="solicitacao.salarioBruto"
                 data-vv-name="salarioBruto"
                 data-vv-as="salário bruto"
                 v-validate="'required'"
                 v-mascara="'moeda'">

          <p class="text-danger" v-show="errors.has('salarioBruto')">{{ errors.first('salarioBruto') }}</p>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('vinculoFundacao')}">
          <label class="control-label" for="vinculoFundacao">Vínculo com a fundação</label>

          <select class="form-control"
                  id="vinculoFundacao"
                  v-model="solicitacao.vinculoFundacao"
                  data-vv-name="vinculoFundacao"
                  data-vv-as="vínculo fundação"
                  v-validate="'required'">
            <option :value="null">Selecione...</option>
            <option value="0">Não sei informar</option>
            <option value="1">Contratação Autônomo</option>
            <option value="2">Contratação PJ</option>
          </select>

          <p class="text-danger" v-show="errors.has('vinculoFundacao')">{{ errors.first('vinculoFundacao') }}</p>
        </div>
      </div>

      <div class="col-lg-5">
        <div class="form-group required" :class="{'has-error': errors.has('funcao')}">
          <label class="control-label" for="funcao">Função</label>

          <input type="text"
                 class="form-control"
                 id="funcao"
                 v-model="solicitacao.funcao"
                 data-vv-name="funcao"
                 data-vv-as="função"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('funcao')">{{ errors.first('funcao') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('dataInicio')}">
          <label class="control-label">Data início</label>

          <datepicker id="dataInicio"
                      v-mascara="'data-mask'"
                      v-model="solicitacao.dataInicioContratacao"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataInicio"
                      data-vv-as="data início"
                      v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataInicio')">{{ errors.first('dataInicio') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-3">
        <div class="form-group" :class="{'has-error': errors.has('horarioTrabalho'), 'required': true}">
          <label class="control-label" for="horarioTrabalho">Horário trabalho</label>

          <input type="text"
                 class="form-control"
                 id="horarioTrabalho"
                 v-model="solicitacao.horarioTrabalho"
                 data-vv-name="horarioTrabalho"
                 data-vv-as="horário trabalho"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('horarioTrabalho')">{{ errors.first('horarioTrabalho') }}</p>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="form-group" :class="{'has-error': errors.has('horarioDenscanso'), 'required': true}">
          <label class="control-label" for="horarioTrabalho">Horário descanso</label>

          <input type="text"
                 class="form-control"
                 id="horarioDenscanso"
                 v-model="solicitacao.horarioDenscanso"
                 data-vv-name="horarioDenscanso"
                 data-vv-as="horário descanso"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('horarioDenscanso')">{{ errors.first('horarioDenscanso') }}</p>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="form-group" :class="{'has-error': errors.has('localTrabalho'), 'required': true}">
          <label class="control-label" for="localTrabalho">Local trabalho</label>

          <input type="text"
                 class="form-control"
                 id="localTrabalho"
                 v-model="solicitacao.localTrabalho"
                 data-vv-name="localTrabalho"
                 data-vv-as="local trabalho"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('localTrabalho')">{{ errors.first('localTrabalho') }}</p>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="form-group" :class="{'has-error': errors.has('telefoneTrabalho'), 'required': true}">
          <label class="control-label" for="telefoneTrabalho">Telefone trabalho</label>

          <input type="text"
                 class="form-control"
                 id="telefoneTrabalho"
                 v-model="solicitacao.telefoneTrabalho"
                 data-vv-name="telefoneTrabalho"
                 data-vv-as="telefone trabalho"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('telefoneTrabalho')">{{ errors.first('telefoneTrabalho') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group" :class="{'has-error': errors.has('observacao')}">
          <label class="control-label" for="observacao">Justificativa contratação</label>

          <textarea class="form-control"
                    id="observacao"
                    v-model="solicitacao.justificativaContratacao"
                    data-vv-name="observacao"
                    data-vv-as="Justificativa"
                    v-validate="">
          </textarea>

          <p class="text-danger" v-show="errors.has('observacao')">{{ errors.first('observacao') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-contratacao-pessoal/componentes/compartilhado/FormDadosContratacao.vue